import { SourceComponents } from '@updater/informant-core';
import { FieldSet as UDSFieldSet } from '@updater/ui-uds';

export const FieldSet: SourceComponents['FieldSet'] = (props) => {
  return <UDSFieldSet {...props} />;
};
